import { useContext } from 'react';
import PropTypes from 'prop-types';
import { UserFeatureContext } from '../contexts/UserFeatureContext';

const IfDebug = ({ children }) => {
  const { debugEnabled } = useContext(UserFeatureContext);

  return debugEnabled ? children : null;
};

IfDebug.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
export default IfDebug;
